<template>
  <b-container fluid>
    <h1 class="display-title">{{ tituloPagina }}</h1>
    <b-row class="my-4">
      <b-col md="4">
        <b-btn
          size="sm"
          variant="success"
          @click="openModal({ id: acciones.nuevo })"
        >
          <b-icon icon="plus"></b-icon>Agregar
        </b-btn>
      </b-col>
      <b-col md="4">
        <b-form-group>
          <b-input-group size="sm">
            <b-form-input v-model="filter" placeholder="Buscar" />
            <b-input-group-append>
              <b-btn :disabled="!filter" @click="filter = ''" variant="primary"
                >Limpiar</b-btn
              >
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group size="sm" horizontal label="Por página: ">
          <b-form-select
            size="sm"
            :options="pageOptions"
            v-model="perPage"
          ></b-form-select>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12" md="12">
        <b-table
          ref="tblCIE10"
          stacked="md"
          responsive
          striped
          hover
          :items="listarCIE10"
          :fields="tblCie10.fields"
          :filter="filter"
          @filtered="onFiltered"
          :per-page="perPage"
          :current-page="currentPage"
          empty-filtered-text="No se encontraron registros"
        >
          <template #cell(acciones)="row">
            <b-dropdown
              id="ddown-divider"
              right
              text="Acciones"
              size="sm"
              variant="primary"
            >
              <b-dropdown-item-button
                @click="openModal({ id: acciones.editar, row: row.item })"
                >Editar</b-dropdown-item-button
              >
              <b-dropdown-item-button
                @click.stop="
                  modalActualizar(row.item, row.index, $event.target)
                "
                >Remover</b-dropdown-item-button
              >
            </b-dropdown>
          </template>
        </b-table>
      </b-col>
    </b-row>
    <hr />
    <b-row>
      <b-col md="6">
        <p>
          Mostrando {{ currentPage }} a {{ perPage }} de {{ totalRows }} items
        </p>
      </b-col>
      <b-col md="6">
        <b-pagination
          size="sm"
          :total-rows="totalRows"
          :per-page="perPage"
          v-model="currentPage"
        ></b-pagination>
      </b-col>
    </b-row>

    <b-modal
      id="mdlCIE10"
      :title="tituloModal"
      :ok-title="okTitle"
      :cancel-title="cancelTitle"
      @ok="operar()"
      ok-variant="success"
      header-bg-variant="dark"
      header-text-variant="light"
    >
      <b-form id="frmCie10">
        <b-form-row>
          <b-col xs="6">
            <b-form-group label="Código" label-for="txtCodigo">
              <b-form-input
                id="txtCodigo"
                v-model="formulario.codigo"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col xs="6">
            <b-form-group label="Grupo" label-for="txtGrupo">
              <b-form-input
                id="txtGrupo"
                v-model="formulario.grupo"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-form-row>
        <b-form-group label="Descripción" label-for="txtDescripcion">
          <b-form-input
            id="txtDescripcion"
            v-model="formulario.descripcion"
          ></b-form-input>
        </b-form-group>
      </b-form>
    </b-modal>
  </b-container>
</template>

<script>
import CIE10Svc from "@/services/cie10";
export default {
  name: "Cie10",
  data() {
    return {
      formulario: {
        codigo: "",
        grupo: "",
        descripcion: ""
      },
      acciones: {
        nuevo: 1,
        editar: 2
      },
      cancelTitle: "Cancelar",
      okTitle: "Guardar",
      tituloModal: "CIE 10",
      tituloPagina: "CIE 10 ",
      filter: "",
      totalRows: null,
      perPage: 10,
      currentPage: 1,
      pageOptions: [5, 10, 15, 25, 50],
      idoperacion: 0,
      tblCie10: {
      fields: [
          {
            key: 'Codigo',
            label: 'Código',
          },
          {
            key: 'ToString',
            label: 'Afección',
          },
          {
            key: 'Descripcion',
            label: 'Descripción',
          },
          {
            key: 'Grupo',
            label: 'Grupo',
          },
          {
            key: 'acciones',
            label: '',
            class: "text-center"
          },
        ],
      }
    };
  },
  methods: {
    openModal(obj) {
      switch (obj.id) {
        case 1:
          this.cleanForm();
          this.idoperacion = 1;
          break;
        case 2:
          this.idoperacion = 2;
          this.getFormData(obj.row.Id)
            .then(r => {
              let formData = r.data.objeto;
              this.formulario.id = formData.Id;
              this.formulario.codigo = formData.Codigo;
              this.formulario.grupo = formData.Grupo;
              this.formulario.descripcion = formData.Descripcion;
            })
            .catch(e => {
              console.log(e);
            });
          break;
      }
      this.$root.$emit("bv::show::modal", "mdlCIE10");
    },

    listarCIE10: function(ctx) {
      let promise = CIE10Svc.getLista({
        id: 0,
        offset: (this.currentPage - 1) * this.perPage,
        limit: this.perPage,
        search: this.filter
      });
      return promise
        .then(r => {
          const items = r.data.rows;
          this.totalRows = r.data.total;
          return items;
        })
        .catch(e => {
          console.log("Erro");
        });
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    getFormData(id) {
      return CIE10Svc.getFormData(id);
    },
    cleanForm() {
      this.formulario.codigo = "";
      this.formulario.grupo = "";
      this.formulario.descripcion = "";
    },
    operar() {
      switch (this.idoperacion) {
        case 1:
          this.registrarCIE10(this.formulario)
            .then(r => {
              this.$refs.tblCIE10.refresh();
            })
            .catch(e => {
              console.log(e);
            });
          break;

        case 2:
          this.editarCIE10(this.formulario)
            .then(r => {
              this.$refs.tblCIE10.refresh();
            })
            .catch(e => {
              console.log(e);
            });
          break;
      }
    },
    registrarCIE10(obj) {
      return CIE10Svc.crear({
        Codigo: obj.codigo,
        Grupo: obj.grupo,
        Descripcion: obj.descripcion
      });
    },
    editarCIE10(obj) {
      return CIE10Svc.cambiar({
        Id: obj.id,
        Codigo: obj.codigo,
        Grupo: obj.grupo,
        Descripcion: obj.descripcion
      });
    }
  },
  created() {
    this.listarCIE10();
  }
};
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/configuraciones/Cie10.vue